import { NavBar } from "./components/nav"

export const SuperDashBoard =()=>{
    return(
        <>
            <NavBar/>
        </>
    )
}